import { render, staticRenderFns } from "./landing.pug?vue&type=template&id=31f1f316&lang=pug&external"
import script from "./landing.js?vue&type=script&lang=js&external"
export * from "./landing.js?vue&type=script&lang=js&external"
import style0 from "./landing.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Multiasistencia\\selfcare\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31f1f316')) {
      api.createRecord('31f1f316', component.options)
    } else {
      api.reload('31f1f316', component.options)
    }
    module.hot.accept("./landing.pug?vue&type=template&id=31f1f316&lang=pug&external", function () {
      api.rerender('31f1f316', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Claim/views/landing/index.vue"
export default component.exports